import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close_regular",
  "use": "close_regular-usage",
  "viewBox": "0 0 11 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 9\" id=\"close_regular\"><defs><path id=\"close_regular_a\" d=\"M15 15V0H0v15z\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><g stroke=\"#666\" stroke-linecap=\"round\"><path d=\"M9.438.563L1.482 8.517M1.563.563l7.954 7.954\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol